import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import BlacklistForm from "@/components/BlacklistForm";
import { toast } from "sonner";
import { FilePlus2 } from "lucide-react";

export default function ReportForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (payload) => {
    setLoading(true);
    try {
      await api.post("/reports", payload);
      toast.success("Đã gửi báo cáo! Chờ tài khoản gốc duyệt.");
      navigate("/bao-cao-cua-toi");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white flex items-center gap-3">
        <FilePlus2 className="w-9 h-9 text-primary" /> Gửi báo cáo
      </h1>
      <p className="text-zinc-500 mt-2 mb-6">Báo cáo khách hàng rủi ro. Báo cáo sẽ hiển thị công khai sau khi được duyệt.</p>
      <BlacklistForm onSubmit={submit} submitting={loading} submitLabel="Gửi báo cáo" />
    </div>
  );
}
